module.exports = __webpack_public_path__ + "static/FSN_Canada_Slate-70e4abaed64654d9032ca07bfa9cc7a4.jpg";